<template>
  <section class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <!--
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        -->
        <el-form-item>
          <el-button type="primary" @click="list">刷新</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <!--列表-->
    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="jobId" label="作业ID"></el-table-column>
        <el-table-column prop="dataKey" label="任务标识"></el-table-column>
        <el-table-column prop="type" label="任务类型"></el-table-column>
        <el-table-column prop="content" label="任务内容"></el-table-column>
        <el-table-column prop="scheduleTime" label="计划时间"></el-table-column>
        <el-table-column prop="status" label="任务状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">初始化</span>
            <span v-if="scope.row.status === 1">执行成功</span>
            <span v-if="scope.row.status === 2">执行失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="tryTimes" label="尝试执行次数"></el-table-column>
        <el-table-column prop="elapsed" label="执行耗时(ms)"></el-table-column>
        <el-table-column prop="result" label="执行结果"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
        <!--
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
          </template>
        </el-table-column>
        -->
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="作业ID">
          <el-input v-model="addForm.jobId"></el-input>
        </el-form-item>
        <el-form-item label="任务标识">
          <el-input v-model="addForm.dataKey"></el-input>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-input v-model="addForm.type"></el-input>
        </el-form-item>
        <el-form-item label="任务内容">
          <el-input v-model="addForm.content"></el-input>
        </el-form-item>
        <el-form-item label="计划时间">
          <el-input v-model="addForm.scheduleTime"></el-input>
        </el-form-item>
        <el-form-item label="任务状态0:等待执行 1:执行成功 2:执行失败">
          <el-input v-model="addForm.status"></el-input>
        </el-form-item>
        <el-form-item label="尝试执行次数">
          <el-input v-model="addForm.tryTimes"></el-input>
        </el-form-item>
        <el-form-item label="执行耗时,单位ms">
          <el-input v-model="addForm.elapsed"></el-input>
        </el-form-item>
        <el-form-item label="执行结果数据">
          <el-input v-model="addForm.result"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="addForm.createTime"></el-input>
        </el-form-item>
        <el-form-item label="修改时间">
          <el-input v-model="addForm.updateTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import mainHeight from "@/utils/mainHeight";
export default {
  name: "AutoTask",
  components: { MyPagination },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/auto-task/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/auto-task/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
